<!-- a11y: prevent default browser submit on Enter / mobile "Search" key; see search-station-form for full rationale. -->
<form
  [formGroup]="routePlannerForm"
  class="route-planner-form h-full"
  (ngSubmit)="submitRoutePlannerForm()"
>
  <div class="flex flex-col gap-4">
    <div class="flex flex-col h-full w-full gap-4">
      <div class="flex flex-col gap-4 bg-white rounded-b-xl p-4 shadow-lg">
        <mot-autocomplete formControlName="line" [readOnly]="true" [displayErrors]="false" appearance="fill"
          inputClass="mot-autocomplete-input--visually-hidden" [label]="lineNumberAndCityText" (onClick)="
            openAutocomplete(getFormControl('line'), lineSearchingText, 'line')
          " (onIconClick)="switchLocations()" fieldClass="cursor-pointer bg-transparent w-full !text-default"
          [hasTrigger]="true">
          <app-line-details trigger [line]="getFormControl('line').value" [showLineCity]="true" (onAgencyClick)="openAgencyContact(false, $event);"/>
        </mot-autocomplete>

        <mot-select formControlName="direction" [options]="directionsOpts$" [label]="directionText"
          class="w-full text-start" [displayErrors]="false" />

        <mot-autocomplete formControlName="boardingStation" [options]="filteredBoardingStops$" [label]="boardingStationText"
          [displayErrors]="false" appearance="fill" fieldClass="w-full text-start"
          [displayFn]="routePlanningService.displayStopName"
          (textChange)="onBoardingStationTextChange($event)"
          (onOptionSelected)="onBoardingStationSelected($event)">
          <ng-template #customOption let-opt>
            <div class="text-bold">{{ getStopName(opt.value) }}</div>
            <!--
              contrast: previously text-black-600 (not defined in Tailwind config -> class is no-op,
              text rendered in the parent's faded default ~#A2A4AB, ~2.5:1 on white, failing AA).
              Switched to text-subText (#5C748F, ~4.9:1) so the secondary stopcode subtitle is readable.
            -->
            <small class="text-subText">{{ stationCodeText }}: {{ opt.value.stopcode }}</small>
          </ng-template>
        </mot-autocomplete>

        <mot-autocomplete formControlName="dropingStation" [options]="filteredDropingStops$" [label]="dropOffStationText"
          [displayErrors]="false" appearance="fill" fieldClass="w-full text-start"
          [displayFn]="routePlanningService.displayStopName"
          (textChange)="onDropingStationTextChange($event)"
          (onOptionSelected)="onDropingStationSelected($event)">
          <ng-template #customOption let-opt>
            <div class="text-bold">{{ getStopName(opt.value) }}</div>
            <small class="text-subText">{{ stationCodeText }}: {{ opt.value.stopcode }}</small>
          </ng-template>
        </mot-autocomplete>

        <div *ngIf="!!getFormControl('line').value && isRouteHasAlternatives" class="flex gap-1 items-center">
          <ng-icon name="circle-exclamation" class="text-2xl text-[#5C748F]" />
           <span class="text-[#5C748F] font-normal">{{ lineAlternativesOrderText }}</span>
          <!-- <span *ngIf="!isLineActive" class="text-red-600 font-normal">קו זה אינו פעיל כרגע</span> -->
        </div>
      </div>
    </div>

    <app-favorite-lines (onFavoriteLineClick)="handleFavoriteLineClick($event)" />
  </div>
</form>


<ng-template #optionTemplate let-opt>
  <div class="text-bold">{{ opt.value.name }}</div>
  <small class="text-subText">{{ stationCodeText }}: {{ opt.value.stopcode }}</small>
</ng-template>
